import * as ActionConfigurationManager from './config.actions';

export const multiProductPaymentTermsChanged = ActionConfigurationManager.MULTI_PRODUCT_FLOW_PAYMENT_TERMS_CHANGED
export const resetMultiProductPaymentTermsChanged = ActionConfigurationManager.RESET_MULTI_PRODUCT_FLOW_PAYMENT_TERMS_CHANGED
